<template>
  <Modal
    :title="$t('edit_item_size')"
    modalId="edit-modal"
    @submit="updateItemSize"
  >
    <form @submit.prevent="updateItemSize">
      <div class="mb-3">
        <label class="form-label">{{ $t('item_size_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="item.size"
          class="form-control"
        />
        <!-- Error for item size -->
        <div v-if="errors.size" class="text-danger mt-2">
          <span>{{ errors.size }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedItemSize: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      item: {
        id: null,
        size: '',
      },
      errorMessage: '',  // General error message (if any)
      errors: {},        // For storing individual field errors
    };
  },
  watch: {
    selectedItemSize: {
      immediate: true,
      handler(newItem) {
        if (newItem && newItem.id) {
          this.item = { ...newItem };
        }
      },
    },
  },
  methods: {
    async updateItemSize() {
      try {
        const response = await this.$axios.patch(
          apiUrls.item_size.update.replace(':pk', this.item.id),
          { size: this.item.size }
        );

        this.toast.success('Size successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'size' field is in errors and assign full error message
            if (error.response.data.size && error.response.data.size.length > 0) {
              // Assign the full error message from the array
              this.errors.size = error.response.data.size[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.item = { id: null, size: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>